<div class="template3">
    <div class="col text-center header-logo-section p-3">
        <a class="" title="Home">
            <img [imgSrc]="'/images/flpi-logo.jpg'" alt="Forever Living Logo" />
        </a>
    </div>
    <div class="body">
        <div class="row">
            <div class="d-sm-none d-md-block col-md-3">
            </div>
            <div class="col-12 col-md-6">
                <div class="">
                    <div *ngIf="isFailure" class="text-center">
                        <div class="alert alert-danger alert-white rounded alertbox">
                            <strong>
                                <span class="icon">
                                    <i class="fa fa-close"></i>
                                </span>&nbsp;&nbsp;&nbsp;&nbsp;{{validationMessage}}</strong>
                        </div>
                    </div>
                    <div *ngIf="isSuccess" class="text-center">
                        <div class="alert alert-success alert-white rounded alertbox">
                            <strong>
                                <span class="icon">
                                    <i class="fa fa-check"></i>
                                </span>
                            </strong>&nbsp;&nbsp;&nbsp;&nbsp;{{validationMessage}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/email-whitelist.component.html